import type { IntentController } from '@jet/environment/dispatching';
import { isSignedIn } from '@jet-app/music-classical/dependencies/subscription-status-coordinator';
import { HomePageIntentController } from '../../home-page/HomePageController';
import { makeHomePageIntent } from '@jet-app/music-classical/intents/HomeIntent';
import { type RouteableIntent } from '@jet-app/music-classical/intents';
import { type ObjectGraph } from '@jet/environment/dependencies';
import { fixLibraryObjectGraph } from './fix-library-object-graph';

export function requiresSignIn<
    I extends RouteableIntent,
    C extends IntentController<I>,
>(controller: C): C {
    return {
        ...controller,

        async perform(intent: I, objectGraph: ObjectGraph): Promise<unknown> {
            if (!isSignedIn(objectGraph)) {
                return HomePageIntentController.perform(
                    makeHomePageIntent({
                        storefront: intent.storefront,
                        language: intent.language,
                    }),
                    objectGraph,
                );
            }

            return controller.perform(
                intent,
                fixLibraryObjectGraph(objectGraph),
            );
        },
    };
}
